import { getRawForrigebokWorks } from "@libry-content/integrations";
import useSWR, { SWRConfiguration } from "swr";
import { useCommonData } from "../layout/CommonDataProvider";
import { getForrigebokReadalikesFilteredOnCatalogue } from "@libry-content/integrations/src/forrigeBok/getForrigebokReadalikesFilteredOnCatalogue";
import { useTranslation } from "../../utils/hooks/useTranslation";

const swrOptions: SWRConfiguration = { revalidateOnFocus: false };

type WorkIdOrIsbn = { workId: string; isbn?: never } | { workId?: never; isbn: string };

export const useForrigeBokWork = (props: WorkIdOrIsbn) => {
  const { workId, isbn } = props;
  const { lang } = useTranslation();

  const key = workId || isbn ? `/forrigebok/works/${workId ?? isbn}` : null;

  const fetcher = workId
    ? () => getRawForrigebokWorks({ workIds: [workId], language: lang })
    : () => getRawForrigebokWorks({ isbns: [isbn ?? "N/A"], language: lang });

  const { data } = useSWR(key, fetcher, swrOptions);

  return data?.works?.[0];
};

export const useReadalikes = (props: WorkIdOrIsbn & { limit: number }) => {
  const { workId, isbn, limit } = props;
  const { site } = useCommonData();

  const key = workId || isbn ? `/forrigebok/readalikes/${workId ?? isbn}` : null;

  return useSWR(
    key,
    () => (site ? getForrigebokReadalikesFilteredOnCatalogue({ site, isbn, workId, limit }) : undefined),
    swrOptions
  );
};
